"use client";

import Link from "next/link";
import { useAuth } from "@/hooks/use-auth";

type PublicAuthLinkProps = {
  className?: string;
};

/** A public navigation link is authenticated only after session verification. */
export function PublicAuthLink({ className }: PublicAuthLinkProps): React.JSX.Element {
  const auth = useAuth();

  // Keep an already verified account available during background revalidation.
  if (auth.isAuthenticated) {
    return <Link href="/app" className={className}>Otevřít EDU</Link>;
  }

  if (!auth.isHydrated) {
    return <span className={className} role="status" aria-live="polite">Ověřuji přihlášení…</span>;
  }

  // A temporary connectivity failure does not prove that the user signed out.
  // The protected entry point retries recovery without claiming an identity.
  if (auth.needsSessionRetry) {
    return <Link href="/app" className={className}>Otevřít EDU</Link>;
  }

  return <Link href="/login" className={className}>Přihlásit se</Link>;
}
